import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
    en: {
        aboutUs: "About Us",
        home: "Home",
        nextDeparturesFrom: "Next departures from",
        network: "Network",
        planRoute: "Plan Route",
        schedules: "Schedules",
        messages: "News / Informations",
        about: "About",
        searchPlaceholder: "Select (Stop / Line / Ticket Office)",
        originStopPlaceHolder: "Departure",
        destinationStopPlaceHolder: "Arrival",
        destination: "Destination",
        planRouteButton: "Plan Trip",
        plannedRoutes: "Trip options",
        duration: "Duration",
        includes: "Includes",
        changes: "change(s)",
        planRouteTimeFilterSelectNow: "Now",
        planRouteTimeFilterSelectStartDate: "Select departure date",
        planRouteTimeFilterSelectedStartDate: "Departure at",
        planRouteTimeFilterSelectEndDate: "Select arrival date",
        planRouteTimeFilterSelectedEndDate: "Arrival at",
        planRouteTimeDisclaimer: "Travel options more suitable for a maximum interval of up to 4 hours from the selected departure time (4 hours earlier for Arrival at option)",
        checkSchedules: "Check Schedules",
        availableLines: "Lines",
        walkAround: "Walk around",
        estimatedWaitingTime: "Estimated waiting time between",
        arrivalEstimatedAt: "Arrival estimated at",
        and: "and",
        or: "or",
        lineInfoStopsTitle: "Stops",
        lineInfoMoreScheds: "more schedules",
        showStops: "Show stops",
        showSchedule: "Show schedule",
        showTrip: "Show route",
        showMap: "Show map",
        moreSchedsTitle: "Schedules",
        noMessagesToShow: "No messages to show",
        noPassingsToShow: "No passings to show",
        noTripsToShow: "No trips to show",
        noInfoToShow: "No information to show",
        selectDate: "Select date",
        provider: "Provider",
        line: "Line",
        viewLine: "View line",
        selectPath: "Select path",
        direction: "Direction",
        directionGo: "Go",
        directionReturn: "Return",
        directionCircular: "Circular",
        daytype: "Day Type",
        locale: "en",
        hoursFilter: "Filter by hours",
        initialHourFilter: "Start time",
        finalHourFilter: "End time",
        filter: "Filter",
        close: "Close",
        done: "Done",
        copyright: "Powered by OPT",
        allRightsReserved: "All rights reserved",
        privacyPolicy: "Privacy Policy",
        notFoundTitle: "404 - Page not found",
        notFoundDescription: "The page you are trying to access does not exist.",
        developedFor: "Developed for Giro",
        contact: "Contact Us",
        name: "Name",
        email: "Email",
        emailWarning: "We'll never share your email with anyone else.",
        subject: "Subject",
        send: "Send",
        sent: "Message sent",
        general: "General",
        emailSuccess: "Message sent successfully.",
        emailError: "An error occurred, please try again later.",
        pageNotFound: "Page not found",
        delayed: "Delayed",
        aheadSchedule: "Ahead of schedule",
        complaintsBook: "Complaints Book",
        phone: "Telephone",
        contactUs: "Talk to us!",
        seeMore: "See more",
        passengerRights: "Passenger's Rights and Duties",
        ticketInfo: "Tickets and fares",
        ticketOffice: "Ticket Office",
        ticketOfficeListPending: "Ticket office list coming soon.",
        ticketOfficeNoAddress: "Address not available",
        ticketOfficeNoSchedule: "Schedule not available",
        moreInfoSoon: "Service will be available soon...",
        fares: "Fares",
        landingPageRoutePlanning: "Plan Route",
        landingPageNetwork: "Network",
        landingPageContacts: "Contacts",
        code: "CODE",
        disclaimer: "The stop times between towns are merely indicative, therefore you should consider the time for the town that precedes the one you're in.",
        notes: "View Notes",
        town: "Location",
        address: "Address",
        postalCode: "Postal Code",
        schedule: "Schedule",
        workingDays: "Working Days",
        saturdays: "Saturdays",
        mondayToSaturday: "Monday to Saturday",
        sundays: "Sundays",
        saturdaysSundaysHolidays: "Saturdays, Sundays and Holidays",
        daily: "Daily",
        exceptSunday: "Monday to Saturday",
        saturdaysHolidays: "Saturdays and Holidays",
        sundaysMondaysIfHolidays: "Sundays and Mondays (if holiday)",
        refundsPolicy: "Return policies",
        provideSubject: "Please, indicate the subject for this contact",
        moreInfoSupportline: "For additional information contact our customer support line +351 253 009 900 (available from 9am to 7pm on working days). National landline network phone call.",
        file: "Attachment",
        fileHelp: "Files should be no bigger than 2 MB. Allowed file types include: jpg jpeg png pdf doc docx.",
        ticketInfoTitle: "<strong>transport tickets</strong> <span>conditions</span>",
        ticketInfoTitleDownload: "Download Full Fares Information",
        vizurContactName: "Translagos-Transportes Publicos, Lda.",
        vizurContactDescription: "Giro service transport operator",
        vizurWebsite: "https://www.vamusalgarve.pt",
        vizurAddress: "Rossio de São João, Lagos 8600-664 Lagos ⋅ Portugal",
        vizurContact: "Tel: 289 899 700 (call to the national landline network)",
        vizurEmail: "E-mail: clientes@eva-bus.com",
        amalContactName: "AMAL",
        amalContactDescription: "Intermunicipal Transport Authority",
        amalWebsite: "https://www.amal.pt",
        amalAddress: "R. General Humberto Delgado, 20. 8000-355 Faro ⋅ Portugal",
        amalContact: "Tel: (+351) 289 880 800",
        amalEmail: "E-mail: geral@amal.pt",
        aboutUsContent: "<p>The Giro brand, initially created to promote the PAMUS – Sustainable Urban Mobility Plan for the Algarve, reflecting AMAL’s commitment to the sustainable development of mobility in the region.</p><p>Aligned with the objectives of the PMUS, the brand was registered by AMAL with the aim of creating a new identity for the mobility services and RPT - Road Public Transport under its responsibility, while also allowing for future expansion to new services that may emerge.</p>",
        contactsPrivacyCheckbox: "I accept the <a href=\"/privacypolicy\">terms and conditions</a>.",
        message: "Write your message.",
        contactsPrivacyInfo: "<p>The data collected is intended to facilitate contacts between you and Vizur.<br/>To learn more about our Privacy Policy click <a href=\"/privacypolicy\">here</a>.</p>",
        contactComplaints: "Complaint",
        contactLostAndFound: "Lost and Found",
        contactInformationRequest: "Information Request",

    },
    pt: {
        aboutUsContent: "<p>A marca Giro, inicialmente utilizada para a promoção do PAMUS – Plano de Ação da Mobilidade Urbana Sustentável no Algarve, assumindo o compromisso que a AMAL tem para com o desenvolvimento sustentável da mobilidade na região.</p><p>Alinhada com os objetivos do PAMUS, a marca foi registada pela AMAL com o objetivo de criar uma nova imagem para os serviços de mobilidade e TPR – Transporte Público Rodoviário da sua competência, permitindo o alargamento a futuros serviços que possam surgir.</p>",
        aboutUs: "Sobre Nós",
        home: "Início",
        nextDeparturesFrom: "Próximas partidas de",
        network: "Rede",
        planRoute: "Planear Rota",
        schedules: "Horários",
        messages: "Notícias / Informações",
        about: "Acerca de",
        searchPlaceholder: "Pesquisar (Paragem / Linha / Posto de Venda)",
        originStopPlaceHolder: "Partida",
        destinationStopPlaceHolder: "Chegada",
        destination: "Destino",
        planRouteButton: "Planear Viagem",
        plannedRoutes: "Opções de viagem",
        duration: "Duração",
        includes: "Inclui",
        changes: "transbordo(s)",
        planRouteTimeFilterSelectNow: "Agora",
        planRouteTimeFilterSelectStartDate: "Escolher data de partida",
        planRouteTimeFilterSelectedStartDate: "Partida às",
        planRouteTimeFilterSelectEndDate: "Escolher data de chegada",
        planRouteTimeFilterSelectedEndDate: "Chegada às",
        planRouteTimeDisclaimer: "Opções de viagem mais adequadas para um intervalo máximo de até 4 horas a partir da hora indicada(4 horas antes para opção de Chegada às)",
        checkSchedules: "Consultar Horários",
        availableLines: "Linhas",
        walkAround: "Ir a pé cerca de",
        estimatedWaitingTime: "Tempo de espera estimado entre as",
        arrivalEstimatedAt: "Chegada estimada às",
        and: "e",
        or: "ou",
        lineInfoStopsTitle: "Paragens",
        lineInfoMoreScheds: "mais horários",
        showStops: "Ver paragens",
        showSchedule: "Ver horário",
        showTrip: "Ver viagem",
        showMap: "Ver mapa",
        moreSchedsTitle: "Horários",
        noMessagesToShow: "Sem mensagens",
        noPassingsToShow: "Sem tempos de passagem",
        noTripsToShow: "Sem viagens para mostrar",
        noInfoToShow: "Sem informação para mostrar",
        selectDate: "Selecione uma data",
        provider: "Operador",
        line: "Linha",
        viewLine: "Ver linha",
        selectPath: "Escolha um percurso",
        direction: "Sentido",
        directionGo: "Ida",
        directionReturn: "Volta",
        directionCircular: "Circular",
        daytype: "Tipo de Dia",
        locale: "pt",
        hoursFilter: "Filtrar por horas",
        initialHourFilter: "Hora inicial",
        finalHourFilter: "Hora final",
        filter: "Filtrar",
        close: "Fechar",
        done: "Concluído",
        copyright: "Powered by OPT",
        allRightsReserved: "Todos os direitos reservados",
        privacyPolicy: "Política de Privacidade",
        notFoundTitle: "404 - Página não encontrada",
        notFoundDescription: "A página à qual está a tentar aceder não existe.",
        developedFor: "Desenvolvido para Giro",
        contact: "Contacto",
        name: "Nome",
        email: "Email",
        emailWarning: "O seu endereço nunca será partilhado com mais nenhuma organização.",
        subject: "Assunto",
        send: "Enviar",
        sent: "Mensagem Enviada",
        general: "Geral",
        emailSuccess: "Mensagem enviada com sucesso.",
        emailError: "Ocorreu um erro, por favor tente mais tarde.",
        pageNotFound: "Página não encontrada",
        delayed: "Atrasado",
        aheadSchedule: "Adiantado",
        complaintsBook: "Livro de Reclamações",
        phone: "Telefone",
        contactUs: "Fale connosco!",
        seeMore: "Ver mais",
        passengerRights: "Direitos e Deveres dos Passageiros",
        ticketInfo: "Títulos e tarifas",
        ticketOffice: "Bilheteiras",
        ticketOfficeListPending: "Lista de bilheteiras brevemente disponível.",
        ticketOfficeNoAddress: "Morada não disponível",
        ticketOfficeNoSchedule: "Horário não disponível",
        moreInfoSoon: "Serviço brevemente disponível...",
        fares: "Tarifário",
        landingPageRoutePlanning: "Planear rota",
        landingPageNetwork: "Rede",
        landingPageContacts: "Contactos",
        code: "CÓD.",
        disclaimer: "Os horários das paragens entre localidades são meramente indicativos pelo que deverá considerar o horário da localidade que antecede o local onde se encontra.",
        notes: "Ver Notas",
        town: "Localidade",
        address: "Morada",
        postalCode: "Código Postal",
        schedule: "Horário",
        workingDays: "Dias Úteis",
        saturdays: "Sábados",
        mondayToSaturday: "Segunda a Sábado",
        sundays: "Domingos",
        saturdaysSundaysHolidays: "Sábados, Domingos e Feriados",
        daily: "Diariamente",
        exceptSunday: "Segunda a Sábado",
        saturdaysHolidays: "Sábados e Feriados",
        sundaysMondaysIfHolidays: "Domingos e Segunda (se feriado)",
        refundsPolicy: "Politicas de devolução",
        provideSubject: "Por favor, indique o assunto relativo a este contacto",
        moreInfoSupportline: "Para mais informações contacte a nossa linha de apoio ao cliente 253 009 900 (disponível das 09h às 19h/dias úteis). Chamada para a rede fixa nacional.",
        file: "Anexo",
        fileHelp: "A dimensão dos ficheiros deve ser inferior a 2 MB. Tipos de ficheiro permitidos: jpg jpeg png pdf doc docx.",
        ticketInfoTitle: "<strong>títulos de transporte</strong> <span>condições</span>",
        ticketInfoTitleDownload: "Descarregar Informação Tarifária Completa",
        vizurContactName: "Translagos-Transportes Publicos, Lda.",
        vizurContactDescription: "Operador de transporte do serviço Giro",
        vizurWebsite: "https://www.vamusalgarve.pt",
        vizurAddress: "Rossio de São João, Lagos 8600-664 Lagos ⋅ Portugal",
        vizurContact: "Tel: 289 899 700 (chamada para a rede fixa nacional)",
        vizurEmail: "E-mail: clientes@eva-bus.com",
        amalContactName: "AMAL",
        amalContactDescription: "Autoridade Intermunicipal de Transportes",
        amalWebsite: "https://www.amal.pt",
        amalAddress: "R. General Humberto Delgado, 20. 8000-355 Faro ⋅ Portugal",
        amalContact: "Tel: (+351) 289 880 800",
        amalEmail: "E-mail: geral@amal.pt",
        contactsPrivacyCheckbox: "Eu aceito <a href=\"/privacypolicy\">termos e condições</a>.",
        message: "Escreva a sua mensagem.",
        contactsPrivacyInfo:"<p>Os dados recolhidos destinam-se a facilitar contactos entre si e a Vizur.<br/>Para saber mais sobre nossa Política de Privacidade clique <a href=\"/privacypolicy\">aqui</a>.</p>",
        contactComplaints: "Reclamação",
        contactLostAndFound: "Perdidos e Achados",
        contactInformationRequest: "Pedido de Informação",
    }
});

export const changeLanguage = (languageKey) => {
    strings.setLanguage(languageKey);
}
